module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Air-ballon-ae103a5377d9e7602a1004f453b70fd4.svg";